import { Controller } from '../utils/controller';
import { clamp } from '../utils/numbers';
import throttle from 'lodash/throttle';

export default class extends Controller {
  static targets = ['header'];

  declare headerTarget: HTMLElement;
  declare hasHeaderTarget: boolean;

  // LOCAL STATE
  private lastScroll: number;
  private offset: number;

  initialize() {
    this.updateUi = throttle(this.updateUi, 50).bind(this);
  }

  connect() {
    this.lastScroll = 0;
    this.offset = 0;
    if (this.hasHeaderTarget) {
      window.addEventListener('scroll', this.updateUi, { passive: true });
    }
  }

  updateUi() {
    const currentScrollPos: number = window.scrollY;
    const difference: number = currentScrollPos - this.lastScroll;
    const newPos: number = this.offset - difference;
    const clamped: number = clamp(newPos, -this.headerTarget.offsetHeight, 0);
    const offset: number = Math.round(clamped);
    const final: string = offset.toString() + 'px';

    if (difference > 0 || this.headerTarget.style.top !== '0px') {
      this.headerTarget.style.transition = 'all 100ms ease-in-out';
      this.headerTarget.style.top = final;
    }

    this.lastScroll = currentScrollPos;
    this.offset = offset;

    if (window.innerHeight + Math.round(currentScrollPos) >= document.body.offsetHeight) {
      this.headerTarget.style.transition = 'top 250ms linear';
      this.headerTarget.style.top = '0px';
    }
  }
}
